/* eslint-disable */
import axios from 'axios';
import { appendTokenToUrl } from '../components/context/Recaptcha';

const { additionalHeaders, loginRootUrl } = window.appAirDrop.config;

export async function sendMobileVerificationCode(phoneData: AddMobilePhone, recaptchaToken?: string) {
  const path = `${loginRootUrl}/login/sendMobileVerificationCode`;
  const response = await axios.post(
    appendTokenToUrl(path, recaptchaToken),
    phoneData,
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    },
  );

  return response;
};

